<template>
	<div id="home">
		<div class="point-list">
			<div v-for="i in $store.state.oHomePage.size" class="point" :class="{active:i==$store.state.oHomePage.index}" @click="$store.state.oHomePage.index = i"></div>
		</div>
		<div class="page-group" :style="{transform:'translateY(-' + (($store.state.oHomePage.index-1) * 100) +'vh)'}">
			<page_1></page_1>
			<page_2></page_2>
			<page_3></page_3>
			<page_4></page_4>
			<page_5></page_5>
			<page_6></page_6>
		</div>
	</div>
</template>

<script>
	import page_1 from '@/modules/home/page_1.vue'
	import page_2 from '@/modules/home/page_2.vue'
	import page_3 from '@/modules/home/page_3.vue'
	import page_4 from '@/modules/home/page_4.vue'
	import page_5 from '@/modules/home/page_5.vue'
	import page_6 from '@/modules/home/page_6.vue'
	export default {
		name: 'home',
		data() {
			return {
			}
		},
		//计算数据
		computed: {
		},
		//参数数据
		props: {},
		//方法
		methods: {
			fnScroll: function(e) {
				var $this = this;
				if($this.$store.state.oHomePage.oFirstFire === null) {
					e = e || window.event;
					var t = null;
					if(e.wheelDelta) {
						//谷歌 (调用了两次)
						// 向下:-120
						// 向上:120
						t = e.wheelDelta < 0;
					} else if(e.detail) {
						// 火狐
						// 向下:3
						// 向上:-3
						t = e.detail > 0;
					}
					if(t > 0) {
						$this.$store.commit("homeNext");
					} else {
						$this.$store.commit("homeBefore");
					}
				}
			},
		},
		//组件
		components: {
			page_1,				
			page_2,
			page_3,
			page_4,
			page_5,
			page_6
		},
		//生命周期-创建
		created() {
		},
		//生命周期-准备就绪
		mounted() {			
			window.onmousewheel = document.onmousewheel = this.fnScroll; //IE/Opera/Chrome
			if(document.attachEvent) {
				document.attachEvent('onmousewheel', this.fnScroll);
			} else if(document.addEventListener) {
				document.addEventListener('DOMMouseScroll', this.fnScroll, false);
			}
		},
		//监控变量
		watch: {
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	@import url("../assets/common.less");
	
	#home {
		overflow: hidden;
		height: 100vh;
		&>.point-list {
			position: fixed;
			z-index: 1000;
			top: 50%;
			right: 20px;
			margin-top: -35px;
			&>.point {
				width: 6px;
				height: 6px;
				background: #0ae;
				border-radius: 50%;
				margin: 8px auto;
				opacity: 0.5;
				cursor: pointer;
				.transition(opacity,0.3s);
				&.active {
					opacity: 1;
					width: 10px;
					height: 10px;
				}
			}
		}
		&>.page-group {
			width: 100vw;
			min-width: 1080px;
			height: 100vh;
			position: relative;
			.transition(all,0.7s);
		}
	}
</style>


// WEBPACK FOOTER //
// Home.vue?e54cc984